import Vue from 'vue'
import VueRouter from 'vue-router'
import ExternalView from '@/views/ExternalView.vue'
import RedirectorView from '@/views/RedirectorView.vue'
import SlugRedirectorView from '@/views/SlugRedirectorView.vue'
import ContractPage from '@/components/Contract/ContractPage.vue'
import AppointmentPage from '@/components/Appointment/AppointmentPage.vue'
import RegistrationPage from '@/components/Registration/RegistrationPage.vue'
import UnsubscribePage from '@/components/Unsubscribe/UnsubscribePage.vue'
import PasswordSet from '@/components/Authentication/PasswordSet.vue'
import Authentication from '@/components/Authentication/Authentication.vue'
import ForgotPassword from '@/components/Authentication/ForgotPassword.vue'
import Authenticated from '@/components/Booking/Authenticated.vue'
import Anonymous from '../components/Booking/Anonymous.vue'
import PaymentProcessorAuthenticated from '@/components/BookingPayment/Authenticated/PaymentProcessor.vue'
import PaymentProcessorAnonymous from '@/components/BookingPayment/Anonymous/PaymentProcessor.vue'
import Home from '@/components/Booking/Home.vue'
import Public from '@/components/Authentication/Public.vue'
import BookingSuggestion from '@/components/BookingSuggestion/BookingSuggestion.vue'
import CardDetailsInvitePage from '../components/CardDetailsInvite/CardDetailsInvitePage.vue'
import CheckoutSessionPage from '@/components/CheckoutSession/CheckoutSessionPage.vue'
import ClientRegistration from '@/components/ClientRegistration/ClientRegistration.vue'
import KioskPage from '@/components/Kiosk/KioskPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/public',
    name: 'home',
    component: Public,
    children: [
      {
        path: 'home',
        name: 'bookingHome',
        component: Home
      },
      {
        path: 'anonymous',
        name: 'anonymous',
        component: Anonymous
      },
      {
        path: 'booking',
        name: 'booking',
        component: Authenticated
      },
      {
        path: 'booking-payment',
        name: 'paymentProcessorAuthenticated',
        component: PaymentProcessorAuthenticated
      },
      {
        path: 'payment',
        name: 'paymentProcessorAnonymous',
        component: PaymentProcessorAnonymous
      },
      {
        path: 'login',
        name: 'login',
        component: Authentication
      },
      {
        path: 'forgot-password',
        name: 'forgotPassword',
        component: ForgotPassword
      },
      {
        path: 'booking-suggestion',
        name: 'bookingSuggestion',
        component: BookingSuggestion
      },
      {
        path: 'checkout-session',
        name: 'checkoutSession',
        component: CheckoutSessionPage
      },
      {
        path: 'client-registration',
        name: 'clientRegistration',
        component: ClientRegistration
      },
      {
        path: 'kiosk',
        name: 'kiosk',
        component: KioskPage
      }
    ]
  },
  {
    path: '',
    name: 'external',
    component: ExternalView,
    children: [
      { path: 'contract', name: 'contract', component: ContractPage },
      { path: 'appointment', name: 'appointment', component: AppointmentPage },
      { path: 'registration', name: 'registration', component: RegistrationPage },
      { path: 'card', name: 'card', component: CardDetailsInvitePage },
      { path: 'unsubscribe', name: 'unsubscribe', component: UnsubscribePage },
      { path: 'public/password-set', name: 'passwordSet', component: PasswordSet }
    ]
  },
  {
    path: '/i',
    name: 'redirect',
    component: RedirectorView
  },
  {
    path: '/go/:slug/:feature?/:postId?',
    name: 'slugRedirect',
    component: SlugRedirectorView
  },
  {
    path: '*',
    redirect: ''
  }
]

const router = new VueRouter({
  routes
})

export default router
